'use strict';

// external imports
import React, {Component} from 'react';
import {connect} from 'react-redux';
import parse from 'html-react-parser';

// prime react imports
import {Toolbar} from 'primereact/toolbar';

// shared imports
import User from '~/shared/src/model/User';

// frontend imports
import {StoreState} from '~/frontend/src/store';
import {isInvalidHTML} from '~/frontend/src/utilities/valueRenderers';


const defaultProps = {};

type DefaultProps = typeof defaultProps;

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * The title of the TreeView
     */
    title : string;

    icon : string;

};

type StateProps = {

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;
};

type ComponentProps = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props & StateProps;

/**
 * Headerbar
 */
class Headerbar extends Component<AllProps> {

    static defaultProps = defaultProps;

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  uid,
                  title,
                  icon
              } = this.props;

        return <Toolbar
            start={<>
                <span
                    key={`${uid}_icon`}
                    className={`yn-header-icon ${icon}`}
                />
                <label
                    key={`${uid}_title`}
                    className="yn-label yn-label-value"
                >
                    {!isInvalidHTML( title ) ? parse( title ) : title}
                </label>
            </>}
            className="yn-panel-headerbar yn-toolbar-horizontal-separator-bottom"
            style={{ zIndex: 6 }}
        />;
    }
}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState, ownProps : ComponentProps ) : StateProps {
    const retVal : StateProps = {
        user: undefined
    };

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

export default connect<StateProps, null, ComponentProps, StoreState>( mapStateToProps, null )( Headerbar );
